import { render, staticRenderFns } from "./EditBuildingDetails.vue?vue&type=template&id=5c422c12"
import script from "./EditBuildingDetails.vue?vue&type=script&lang=js"
export * from "./EditBuildingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports